import * as React from "react";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import axios from "axios";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { MyCommandCell, CustomHeaderActionCell } from "./HelperComponent";
import withValueField from "../../../Shared/withValueField";
import { CellRender, GridNoRecord, StatusCell, isCalculatedBillRateEnabled } from "../../../Shared/GridComponents/CommonComponents";
import { IDropDownModel } from "../../../Shared/Models/IDropDownModel";
import { filterBy, State, toODataString } from "@progress/kendo-data-query";
import { currencyFormatter, errorToastr, getFormattedDate, warningToastr } from "../../../../HelperMethods";
import ConfirmationModal from "../../../Shared/ConfirmationModal";
import { INLINE_BILL_ERROR_MSG, INLINE_EXTENSION_CONTRACT_WARNING_MSG, REMOVE_CONTRACT_CONFIRMATION_MSG } from "../../../Shared/AppMessages";
import { ErrorComponent, KendoFilter } from "../../../ReusableComponents";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { BillRateStatus, ExtensionStatuses, ServiceCategory } from "../../../Shared/AppConstants";
import _ from "lodash";
import { AppPermissions } from "../../../Shared/Constants/AppPermissions";
import auth from "../../../Auth";
import PayRateConfirmationModal from "../../../Shared/PayRateConfirmationModal";

const CustomDropDownList = withValueField(DropDownList);
const defaultItem = { name: "Select...", id: null };

export interface ProviderContractsProps {
    candSubmissionId: string;
    canEdit?: boolean;
    clientId?: string;
    positionId?: string;
    locationId?: string;
    divisionId?: string;
    isPayRateEnabled?: boolean;
    isCalculateBillRateEnable?: boolean;
    vendorTierProviderRate?: any;
    isVendorTier?: boolean;
    markupPer?: any;
    isExpenseRateCard?: boolean;
}

export interface ProviderContractsState {
    contract: any;
    totalContract?: number;
    gridBillRate?: any;
    gridHolidayBillRate?: any;
    actualBillRate?: number;
    actualHolidayRate?: number;
    serviceCatId?: any;
    serviceCategoryIntId?: any;
    serviceTypeId?: any;
    rateCardId?: any;
    dataState: any;
    serviceCategory: Array<IDropDownModel>;
    originalserviceCategory: Array<IDropDownModel>;
    serviceTypes: Array<IDropDownModel>;
    originalserviceTypes: Array<IDropDownModel>;
    date?: Date;
    showRemoveConfirmationModal?: boolean;
    showPayRateConfirmationModal?: boolean;
    showLoader?: boolean;
    payRate?: any;
    holidayPayRate?: any;
    billRates?: any;
    holidayBillRates?: any;
    isDirty?: boolean;
    pivotDateType?: string;
    allowOverride?: any;
}

const initialDataState = {
    skip: 0,
    take: 50,
};

class ProviderContracts extends React.Component<ProviderContractsProps, ProviderContractsState> {
    CustomHeaderActionCellTemplate: any;
    CommandCell;
    public dataItem: any;
    public rates: any;
    editField = "inEdit";
    public isSubmit = false;
    private originalLevels = [];
    subBillRateId: string;
    candSubExtId: string;
    constructor(props: ProviderContractsProps) {
        super(props);
        this.state = {
            contract: [],
            serviceCategory: [],
            originalserviceCategory: [],
            serviceTypes: [],
            originalserviceTypes: [],
            date: getFormattedDate(),
            dataState: initialDataState,
            showLoader: true,
            payRate: 0,
            holidayPayRate: 0,
            billRates: 0,
            holidayBillRates: 0
        };
        this.initializeHeaderCell();
        this.initializeActionCell();
    }

    componentDidMount() {
        if (this.props.candSubmissionId) {
            this.getExtensions(this.props.candSubmissionId);
        } else {
            this.setState({ showLoader: false });
        }
    }

    initializeActionCell = () => {
        this.CommandCell = MyCommandCell({
            edit: this.enterEdit,
            remove: (dataItem) => this.setState({ showRemoveConfirmationModal: true }, () => this.dataItem = dataItem),
            add: this.add,
            discard: this.discard,
            update: this.update,
            cancel: this.cancel,
            editField: this.editField
        });
    };

    initializeHeaderCell = () => {
        this.CustomHeaderActionCellTemplate = CustomHeaderActionCell({
            add: this.addNew
        });
    };

    getExtensions = (candSubmissionId) => {
        let queryStr = `$filter=status eq '${ExtensionStatuses.APPROVED}'`;
        this.setState({ showLoader: true });
        axios.get(`api/candidates/${candSubmissionId}/assignmentextensions?${queryStr}`)
            .then((res:any) => {
                if(res.data.length > 0){
                    this.candSubExtId = res.data[0].candSubExtId != null && res.data[0].candSubExtId;
                }
                this.getBillRates(this.state.dataState, this.candSubExtId);
            });
    };

    getBillRates = (dataState, candSubExtId?) => {
        var queryStr = `${toODataString(dataState, { utcDates: true })}`;
        var queryParams = `candSubId eq ${this.props.candSubmissionId} and status eq '${BillRateStatus.APPROVED}' and candSubExtId eq null`;

        if (candSubExtId) {
            queryParams = `candSubId eq ${this.props.candSubmissionId} and status eq '${BillRateStatus.APPROVED}' and candSubExtId eq ${candSubExtId}`;
        }

        var finalQueryString = KendoFilter(dataState, queryStr, queryParams);
        this.setState({ showLoader: true });
        axios.get(`api/candidates/billrate?${finalQueryString}`).then((res:any) => {
            console.log("res.data", res.data);
            this.setState({
                contract: res.data.filter((i) => new Date(i.endDate) >= this.state.date),
                showLoader: false,
                dataState: dataState,
            });
            this.getBillRatesCount(dataState, candSubExtId);
            this.originalLevels = res.data;
        });
    };

    getBillRatesCount = (dataState, candSubExtId?) => {
        var finalState: State = {
            ...dataState,
            take: null,
            skip: 0,
        };

        var queryStr = `${toODataString(finalState, { utcDates: true })}`;
        var queryParams = `candSubId eq ${this.props.candSubmissionId} and status eq '${BillRateStatus.APPROVED}' and candSubExtId eq null`;

        if (candSubExtId) {
            queryParams = `candSubId eq ${this.props.candSubmissionId} and status eq '${BillRateStatus.APPROVED}' and candSubExtId eq ${candSubExtId}`;
        }

        var finalQueryString = KendoFilter(dataState, queryStr, queryParams);

        axios.get(`api/candidates/billrate?${finalQueryString}`).then((res:any) => {
            this.setState({
                totalContract: res.data.filter((i) => new Date(i.endDate) >= this.state.date).length
            });
        });
    };

    getServiceCategories = () => {
        axios.get(`api/candidates/servicecat`).then((res) => {
            this.setState({ serviceCategory: res.data, originalserviceCategory: res.data });
        });
    }

    getServiceTypes = (id, clientId, candSubmissionId) => {
        if (id !== null) {
            axios.get(`api/candidates/candsub/servicetype?candSubmissionId=${candSubmissionId}&clientId=${clientId}&serviceCatId=${id}`).then((res) => {
                this.setState({ serviceTypes: res.data, originalserviceTypes: res.data });
            })
        } else {
            this.setState({ serviceTypes: [], originalserviceTypes: [] });
        }
    }

    generateId = data => data.reduce((acc, current) => Math.max(acc, current.intId), 0) + 1;

    checkDuplicate = (serviceType) => {
        let serviceTypeExists = this.state.contract.filter(i => i.serviceType == serviceType)
        if (serviceTypeExists.length > 1) {
            return false;
        }
        else {
            return true;
        }
    }

    addNew = () => {
        let hasUnsavedData = this.state.contract.filter(i => i.inEdit == true).length > 0;
        let hasError = hasUnsavedData ? true : false;
        if (hasError) {
            warningToastr(INLINE_EXTENSION_CONTRACT_WARNING_MSG);
            return false;
        }
        this.getServiceCategories();

        this.isSubmit = false;
        const newDataItem = { inEdit: true, intId: this.generateId(this.state.contract), serviceCatId: this.state.serviceCatId, serviceTypeId: this.state.serviceTypeId, gridBillRate: this.state.gridBillRate, gridHolidayBillRate: this.state.gridHolidayBillRate, rateCardId: this.state.rateCardId, status: BillRateStatus.PENDINGAPPROVAL, statusIntId: 20, pivotDateType: this.state.pivotDateType, allowOverride: this.state.allowOverride, serviceCategoryIntId: this.state.serviceCategoryIntId };

        { this.setState({ serviceCategory: this.state.originalserviceCategory }) }
        this.setState({
            contract: [newDataItem, ...this.state.contract]
        });
    };

    add = (dataItem, isPayRate?) => {
        this.isSubmit = true;
        let isServiceCatTime = dataItem.serviceCategory == ServiceCategory.TIME ? true : false
        if (this.checkDuplicate(dataItem.serviceType)) {
            if (dataItem.serviceCategory == ServiceCategory.EXPENSE ? dataItem.serviceCategory && dataItem.serviceType && dataItem.gridBillRate > 0 : dataItem.serviceCategory && dataItem.serviceType && dataItem.gridBillRate > 0 && dataItem.gridHolidayBillRate > 0) {
                if (isPayRate == null || isPayRate == undefined || isPayRate == false || isPayRate >= 0) {
                    dataItem.inEdit = undefined;
                }
                dataItem.markupPer = isCalculatedBillRateEnabled(isServiceCatTime, this.props.isCalculateBillRateEnable, this.props.isVendorTier, this.props.isPayRateEnabled) ? this.props.markupPer : null;
                dataItem.intId = this.generateId
                    (this.originalLevels);

                this.originalLevels.unshift(dataItem);

                if (isPayRate == null || isPayRate == undefined || isPayRate == false || isPayRate >= 0) {
                    this.setState({ 
                        contract: [...this.state.contract],
                        serviceTypes: [],
                        originalserviceTypes: []
                    });
                }
            }
        }
        else {
            errorToastr(INLINE_BILL_ERROR_MSG);
        }
    };

    enterEdit = (dataItem) => {
        this.rates = dataItem;
        this.subBillRateId = dataItem.subBillRateId;
        let isServiceCatTime = dataItem.serviceCategory == ServiceCategory.TIME ? true : false
        if(dataItem.subBillRateId == null || dataItem.subBillRateId == undefined){
            this.getServiceTypes(dataItem.serviceCatId, this.props.clientId, this.props.candSubmissionId)
        }
        dataItem.gridHolidayBillRate = dataItem.serviceCategory == ServiceCategory.EXPENSE ?  0 : dataItem.gridHolidayBillRate;
        let hasUnsavedData = this.state.contract.filter(i => i.inEdit == true).length > 0;
        let hasError = hasUnsavedData ? true : false;
        if (hasError) {
            warningToastr(INLINE_EXTENSION_CONTRACT_WARNING_MSG);
            return false;
        }
        this.isSubmit = false;
        var disableBillRateForVendor = this.disableBillRateForVendor(dataItem);

        this.setState({
            contract: this.state.contract.map(item => item.intId === dataItem.intId ? { ...item, inEdit: true, disableBillRate: disableBillRateForVendor } : item),
            actualBillRate: dataItem.gridBillRate,
            actualHolidayRate: dataItem.gridHolidayBillRate
        }, () => {if (isCalculatedBillRateEnabled(isServiceCatTime, this.props.isCalculateBillRateEnable, this.props.isVendorTier, this.props.isPayRateEnabled) && dataItem.subBillRateId !== null && dataItem.subBillRateId !== undefined){
                this.setState({ showPayRateConfirmationModal: true })
            }});
    }

    update = (dataItem, isPayRate?) => {
        this.isSubmit = true;
        if (this.checkDuplicate(dataItem.serviceType)) {
            if (dataItem.serviceCategory == ServiceCategory.EXPENSE ? dataItem.serviceCategory && dataItem.serviceType && dataItem.gridBillRate > 0 : dataItem.serviceCategory && dataItem.serviceType && dataItem.gridBillRate > 0 && dataItem.gridHolidayBillRate > 0) {
                
                if (dataItem.gridBillRate != this.state.actualBillRate) {
                    dataItem.status = BillRateStatus.PENDINGAPPROVAL;
                    dataItem.statusIntId = 20;
                } else if (dataItem.gridHolidayBillRate != this.state.actualHolidayRate) {
                    dataItem.status = BillRateStatus.PENDINGAPPROVAL;
                    dataItem.statusIntId = 20;
                }
                const data = [...this.state.contract];
                const updatedItem = { ...dataItem, inEdit: undefined };

                this.updateItem(data, updatedItem);

                if (isPayRate == null || isPayRate == undefined || isPayRate == false) {
                    this.setState({ contract: data });
                }
            }
        }
        else {
            errorToastr(INLINE_BILL_ERROR_MSG);
        }
    }

    updateItem = (data, item) => {
        let index = data.findIndex(p => p === item || (item.subBillRateId && p.subBillRateId === item.subBillRateId));
        if (index >= 0) {
            data[index] = { ...item };
        }
    }

    remove = (dataItem) => {
        const data = [...this.state.contract];
        this.removeItem(data, dataItem);
        this.setState({ contract: data, showRemoveConfirmationModal: false });
    }

    removeItem(data, item) {
        let index = data.findIndex(p => p === item || (item.id && p.id === item.id));
        if (index >= 0) {
            data.splice(index, 1);
        }
    }

    cancel = (dataItem) => {
        const originalItem = this.originalLevels.find((p) => p.subBillRateId === dataItem.subBillRateId);
        originalItem["inEdit"] = undefined;
        const data = this.state.contract.map((item) => item.subBillRateId === originalItem.subBillRateId ? originalItem : item);
        this.setState({ contract: data });
    }

    discard = dataItem => {
        const data = [...this.state.contract];
        this.removeItem(data, dataItem);

        this.setState({ contract: data });
    };

    onDataStateChange = (changeEvent) => {
        if (this.props.candSubmissionId) {
            this.getBillRates(changeEvent.dataState);
        }
    };

    updateState = (value, props) => {
        const data = this.state.contract.map((item) =>
            item.intId === props.dataItem.intId
                ? { ...item, [props.field]: value }
                : item
        );
        this.setState({ contract: data });
    };

    itemChange = (event) => {
        const data = this.state.contract.map(item =>
            item.intId === event.dataItem.intId ?
                { ...item, [event.field]: event.value } : item
        );

        this.setState({ contract: data });
    }

    handleFilterChange = (event) => {
        var name = event.target.props.id;
        var originalArray = "original" + name;
        this.state[name] = this.filterData(event.filter, originalArray);
        this.setState(this.state);
    }

    filterData(filter, originalArray) {
        const data1 = this.state[originalArray];
        return filterBy(data1, filter);
    }

    ServiceCategoryCell = (props) => {
        return (
            <>
                {!props.dataItem.inEdit || props.dataItem.subBillRateId !== undefined
                    ? (
                        <td contextMenu="Service Category">
                            {props.dataItem.serviceCategory !== undefined && props.dataItem.serviceCategory}
                        </td>
                    ) :
                    (<td contextMenu="Service Category" className="myOrderContainer-dropdownList">
                        <CustomDropDownList
                            className={"form-control"}
                            data={this.state.serviceCategory}
                            name="serviceCategory"
                            textField="name"
                            id="serviceCategory"
                            valueField="id"
                            defaultItem={defaultItem}
                            value={(props.dataItem.serviceCatId)}
                            onChange={(e) => {
                                props.dataItem.serviceCatId = e.value.id;
                                props.dataItem.serviceCategoryIntId = e.value.intId;
                                props.dataItem.serviceCategory = e.value.name;
                                props.dataItem.serviceTypeId = null;
                                props.dataItem.pivotDateType = null;
                                props.dataItem.allowOverride = null;
                                props.dataItem.rateCardId = null;
                                props.dataItem.billType = "-";
                                props.dataItem.gridBillRate = 0;
                                props.dataItem.gridHolidayBillRate = 0;
                                this.setState({ contract: this.state.contract, serviceTypes:[], originalserviceTypes: [] })
                                this.getServiceTypes(e.value.id, this.props.clientId, this.props.candSubmissionId)
                                props.dataItem['disableBillRate'] = this.disableBillRateForVendor(props.dataItem);
                            }}
                            filterable={this.state.originalserviceCategory.length > 5 ? true : false}
                            onFilterChange={this.handleFilterChange}
                        />
                    </td>
                    )
                }
            </>
        );
    }

    disableBillRateForVendor = (dataItem) => {
        const { isExpenseRateCard } = this.props;
        if (dataItem.serviceCategory == ServiceCategory.EXPENSE
            && isExpenseRateCard && auth.hasPermissionV2(AppPermissions.PAY_RATE_VIEW)) {
            return true;
        }else{
            return false;
        }
    }

    ServiceTypeCell = (props) => {
        return (
            <>
                {!props.dataItem.inEdit || props.dataItem.subBillRateId !== undefined
                    ? (
                        <td contextMenu="Service Type">
                            {props.dataItem.serviceType !== undefined && props.dataItem.serviceType}
                        </td>
                    ) :
                    (<td contextMenu="Service Type" className="myOrderContainer-dropdownList">
                        <CustomDropDownList
                            className={"form-control"}
                            data={this.state.serviceTypes}
                            name="serviceType"
                            textField="name"
                            id="serviceTypes"
                            valueField="rateCardId"
                            defaultItem={defaultItem}
                            value={(props.dataItem.rateCardId)}
                            onChange={(e) => {
                                props.dataItem.serviceType = e.value.name;
                                props.dataItem.serviceTypeId = e.value.id;
                                props.dataItem.pivotDateType = e.value.pivotDateType;
                                props.dataItem.allowOverride = e.value.allowOverride;
                                props.dataItem.rateCardId = e.value.rateCardId;
                                props.dataItem.billType = e.value.billType;
                                props.dataItem.gridBillRate = props.dataItem?.disableBillRate ? e.value.billRate : 0;
                                props.dataItem.gridHolidayBillRate = 0;
                                this.rates = props.dataItem;
                                let isServiceCatTime = props.dataItem.serviceCategory == ServiceCategory.TIME ? true : false
                                this.setState({ contract: this.state.contract })
                                if (isCalculatedBillRateEnabled(isServiceCatTime, this.props.isCalculateBillRateEnable, this.props.isVendorTier, this.props.isPayRateEnabled)){
                                    this.subBillRateId = undefined;
                                    this.setState({ showPayRateConfirmationModal: true })
                                }
                            }}
                            filterable={this.state.originalserviceTypes.length > 5 ? true : false}
                            onFilterChange={this.handleFilterChange}
                        />
                    </td>
                    )
                }
            </>
        );
    }

    BillRateField = (props) => {
        const { dataItem, field } = props;
        let isServiceCatTime = dataItem.serviceCategory == ServiceCategory.TIME ? true : false;
        return (
            <td contextMenu="Bill Rate" className="text-right pr-4">
                {dataItem.inEdit && !isCalculatedBillRateEnabled(isServiceCatTime, this.props.isCalculateBillRateEnable, this.props.isVendorTier, this.props.isPayRateEnabled) ? (
                        <div className="input-desciption">
                            <NumericTextBox
                                disabled={dataItem?.disableBillRate}
                                className="form-control"
                                placeholder="Enter Bill Rate"
                                value={isNaN(dataItem[field]) ? 0 : dataItem[field]}
                                format="c2"
                                min={0}
                                max={99999}
                                name="billRate"
                                onChange={(event) => this.updateState(event.target.value, props)}
                            />
                            {this.isSubmit && props.dataItem.gridBillRate <= 0 && <ErrorComponent message="Bill Rate should be greater than 0" />}
                        </div>
                    ) : (
                        <span
                            title={dataItem[field]}
                        >
                            {currencyFormatter(dataItem[field])}
                        </span>
                    )}
            </td>
        );
    };

    HolidayRateField = (props) => {
        const { dataItem, field } = props;
        let isServiceCatTime = dataItem.serviceCategory == ServiceCategory.TIME ? true : false;
        return (
            <td contextMenu="Holiday Rate" className="text-right pr-4">
                {dataItem.inEdit && !isCalculatedBillRateEnabled(isServiceCatTime, this.props.isCalculateBillRateEnable, this.props.isVendorTier, this.props.isPayRateEnabled) ? (
                    <div className="input-desciption">
                        <NumericTextBox
                            disabled={dataItem.serviceCategory == ServiceCategory.EXPENSE ? true : false}
                            className="form-control"
                            placeholder="Enter Holiday Bill Rate"
                            value={isNaN(dataItem[field]) ? 0 : dataItem[field]}
                            format="c2"
                            min={0}
                            max={99999}
                            name="holidayBillRate"
                            onChange={(event) => this.updateState(event.target.value, props)}
                        />
                        {this.isSubmit && dataItem.serviceCategory == ServiceCategory.TIME && props.dataItem.gridHolidayBillRate <= 0 && <ErrorComponent message="Holiday Rate should be greater than 0" />}
                    </div>
                ) : (
                    <span
                        title={dataItem[field]}
                    >
                        {currencyFormatter(dataItem[field])}
                    </span>
                )}
            </td>
        );
    };

    getContractData() {
        let hasDuplicateRecords = false;
        let hasUnsavedData = this.state.contract.filter(i => i.inEdit == true).length > 0;
        let duplicateContracts = this.state.contract.map(x => x.serviceTypeId);
        let duplicateContractsCount = duplicateContracts.length;
        let uniqueContractsCount = _.uniq(duplicateContracts).length;
        let hasTimeData = this.state.contract.filter(i => i.serviceCategory == ServiceCategory.TIME).length <= 0;

        if(duplicateContractsCount != uniqueContractsCount){
            hasDuplicateRecords = true;
        }
        
        return ({ data: this.state.contract, hasError: hasUnsavedData ? true : false, hasDuplicateRecords, hasNoTimeCategoryData: hasTimeData ? true : false });
    }

    handleChange = (e) => {
        let change = { isDirty: true };
        change[e.target.name] = e.target.value;
        this.setState(change);

        if(e.target.name == "payRate"){
            this.setState({
                billRates: this.props.markupPer == undefined ? 0 : ((1 + this.props.markupPer / 100) * e.target.value)
            });
        }else{
            this.setState({
                holidayBillRates: this.props.markupPer == undefined ? 0 : ((1 + this.props.markupPer / 100) * e.target.value)
            });
        }
    };

    handleYes = () => {
        let gridBillRate = this.props.markupPer == undefined ? 0 : ((1 + this.props.markupPer / 100) * this.state.payRate).toFixed(2);
        let gridHolidayBillRate = this.props.markupPer == undefined ? 0 : ((1 + this.props.markupPer / 100) * this.state.holidayPayRate).toFixed(2);

        const data = this.state.contract.map((i) =>
            i.intId === this.rates.intId
                ? { ...i, gridBillRate: gridBillRate, gridHolidayBillRate: gridHolidayBillRate, markupPer: this.props.markupPer }
                : i
        );

        this.setState({
            contract: data,
            payRate: 0,
            holidayPayRate: 0,
            billRates: 0,
            holidayBillRates: 0,
            showPayRateConfirmationModal: false
        }, () => {
            if (this.rates.subBillRateId !== null && this.rates.subBillRateId !== undefined) {
                this.update(data.filter(i => i.intId == this.rates.intId)[0], true);
            } else {
                this.add(data.filter(i => i.intId == this.rates.intId)[0], true);
            }
        });
    }

    handleNo = () => {
        this.setState({
            payRate: 0,
            holidayPayRate: 0,
            billRates: 0,
            holidayBillRates: 0,
            showPayRateConfirmationModal: false
        });
    }

    render() {
        const { canEdit } = this.props;
        return (
            <>
                <div className="">
                    <div className="row mt-2">
                        <div className="col-12" id="nameyoursearch">
                            <div className="createjoborderstep4-a" id="createjoborderstep">
                                <div className="table-responsive tableShadow myOrderContainer-dropdownList">
                                    <Grid
                                        className="kendo-grid-custom k-widget lastchild global-action-grid-lastchild"
                                        style={{ height: 'auto' }}
                                        sortable={false}
                                        onDataStateChange={this.onDataStateChange}
                                        onItemChange={this.itemChange}
                                        editField="inEdit"
                                        selectedField="selected"
                                        data={this.state.contract}
                                        {...this.state.dataState}
                                        total={this.state.totalContract}
                                        filterable={false}
                                        columnMenu={false}
                                    >
                                        <GridNoRecords>{GridNoRecord(this.state.showLoader, true)}</GridNoRecords>

                                        <GridColumn
                                            field="serviceCategory"
                                            title="Service Category"
                                            className="myOrderContainer-K-textbox"
                                            cell={this.ServiceCategoryCell}
                                        />
                                        <GridColumn
                                            field="serviceType"
                                            title="Service Type"
                                            className="myOrderContainer-K-textbox"
                                            cell={this.ServiceTypeCell}
                                        />
                                        <GridColumn
                                            field="billType"
                                            title="Bill Type"
                                            className="myOrderContainer-K-textbox"
                                            cell={(props) => CellRender(props, "Bill Type")}
                                        />
                                        <GridColumn
                                            field="gridBillRate"
                                            title="Bill Rate"
                                            headerClassName="text-right pr-4"
                                            className="myOrderContainer-K-textbox"
                                            cell={this.BillRateField}
                                        />
                                        <GridColumn
                                            field="gridHolidayBillRate"
                                            title="Holiday Rate"
                                            headerClassName="text-right pr-4"
                                            className="myOrderContainer-K-textbox"
                                            cell={this.HolidayRateField}
                                        />
                                        <GridColumn
                                            field="status"
                                            title="Status"
                                            cell={StatusCell}
                                        />
                                        <GridColumn
                                            sortable={false}
                                            cell={this.CommandCell}
                                            width="110px"
                                            headerCell={this.CustomHeaderActionCellTemplate}
                                        />
                                    </Grid>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ConfirmationModal
                        message={REMOVE_CONTRACT_CONFIRMATION_MSG()}
                        showModal={this.state.showRemoveConfirmationModal}
                        handleYes={() => this.remove(this.dataItem)}
                        handleNo={() => {
                            this.setState({ showRemoveConfirmationModal: false });
                        }}
                    />
                    <PayRateConfirmationModal
                        showModal={this.state.showPayRateConfirmationModal}
                        handleYes={() => this.handleYes()}
                        handleNo={() => this.handleNo()}
                        handleChange={this.handleChange}
                        subBillRateId={this.subBillRateId}
                        payRate={this.state.payRate}
                        holidayPayRate={this.state.holidayPayRate}
                        billRates={this.state.billRates}
                        holidayBillRates={this.state.holidayBillRates}
                    />
                </div>
            </>
        );
    }
}

export default ProviderContracts;